import { v4 as uuidv4 } from "uuid"

/**
 * Generates a UUID using the uuid library
 */
export function generateUUID(): string {
  return uuidv4()
}
